export const parseJwt = (token: string) => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
};

export const getPropertyFromJwt = (token: string, property: string): string | number | boolean | null | undefined => {
  try {
    const parsedToken = parseJwt(token);

    if (!parsedToken.hasOwnProperty(property)) {
      return undefined;
    }

    return parsedToken[property];
  } catch {
    throw new Error('Unable to parse JWT');
  }
};